import { ApiService } from '../../services/api_service';
import { AuswahlErfassungsmodus } from './functions/AuswahlErfassungsmodus';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { CustomDatensatzRfg, hasEntityActivatedRfg, getFormRfgBtns, gibtEMIEJMAED } from './functions/CustomDatensatzRfg';
import { CustomRowName } from './functions/CustomRowName';
import { DataService } from '../../services/data_service';
import { DatenauswertungJahrauswahl } from '../datenauswertung/DatenauswertungJahrauswahl';
import { DateneingabeCO2KomplexForm } from './DateneingabeCO2KomplexForm';
import { DateneingabeCO2Scope3Auswahl } from './DateneingabeCO2Scope3AuswahlNew';
// import { DetaillierteErfassungScope3 } from './functions/DetaillierteErfassungScope3';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import formStyle from '../../core/forms/style/WForm.less';
import { getAutoSaveIntervall } from './assistent/assistent_helpers';
import { getCO2Scope3Auswahl } from './functions/getCO2Scope3Auswahl';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert, filterCO2Scope3StructureNachgelagert } from './functions/getCO2Scope3Structure';
import { getCustomFormConfig } from './co2_custom/getCustomFormConfig';
import { getFormKey } from '../../main/functions/getFormKey';
import { getGewerk } from '../../main/functions/getGewerk';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings, findStandorteTabRouting } from './functions/StandorteGruppen';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { sortKomplexDataRows } from '../../main/functions/sortKomplexDataRows';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { TriggerService } from '../../core/trigger/trigger_service';
import { Validierung } from '../datenauswertung/elements/Validierung';
import { ValidierungHinweise } from '../datenauswertung/elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { recordHiddenRows, hideKomplexRows } from '../../main/functions/hideKomplexRows';
import { DateneingabeAnAbreiseDetailWrapper } from './DateneingabeAnAbreiseDetailWrapper';
import { DateneingabePendelnKampagneWrapper } from './DateneingabePendelnKampagneWrapper';
import { processKennziffernBerechnung } from '../../main/functions/processKennzahlenBerechnng';
import { onFormChangeInteractiveCO2 } from './assistent/items/assistent_config_co2scope3';
import { WFormData } from '../../core/forms/WFormFramework';
import { i18n2 } from '../../i18n/i18n_core';

interface DateneingabeCO2KomplexProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
    scrollLeft: number;
    style?: React.CSSProperties;
    getScrollTop?: () => number;
    setScrollTop?: (scrollTop: number) => void;
}

interface DateneingabeCO2KomplexState {
    konfig: any;
    jahr_von: number;
    jahr_bis: number;
    jahr_min: number;
    jahr_max: number;
    entities: any;
    loadingDone: boolean;
    doRenderForm: any;
    extraForms: any;
    showBereiche: any;
    dataForOptionalDialog: any;
    dataForOptionalDialog2: any;
    eigenstrom_typen_s: Array<any>;
    eigenwaerme_typen_w: Array<any>;
    currentYear: number;
    presetFormConfig: any;
    forceNoRenderOnce: boolean;
    jahrForScope3Auswahl: number;
    validation: any;
    mouseOverHinweise: number;
    erfassungsmodus: string;
    activeFormKey: string;
}

export class DateneingabeCO2Komplex extends React.Component<DateneingabeCO2KomplexProps, DateneingabeCO2KomplexState> {

    constructor(props: any) {
        super(props);
        const jahr_max = Moment().year();
        let konfig;
        let jahr_min = 2015;
        // let jahr_min = 2010;
        let jahr_von;
        let jahr_bis;

        if (Array.isArray(props.data[IDs.ENT_KONFIGURATION]) && props.data[IDs.ENT_KONFIGURATION].length > 0) {
            konfig = props.data[IDs.ENT_KONFIGURATION][0];
            const startjahr: number = (konfig || {}).startjahr_datenerfassung || null;
            jahr_min = (props.data.first_year > 2009 && props.data.first_year < jahr_min) ? props.data.first_year : jahr_min;
            jahr_min = (startjahr > jahr_min) ? startjahr : jahr_min;
            // console.log('Konfig in Komplex: ', konfig);
            // if (konfig.startjahr_datenerfassung && +konfig.startjahr_datenerfassung > 1900) {
            //     jahr_min = konfig.startjahr_datenerfassung;
            // }

            if (konfig.dateneingabe_form_jahr_von && +konfig.dateneingabe_form_jahr_von > 1900) {
                jahr_von = konfig.dateneingabe_form_jahr_von;
            } else {
                jahr_von = (jahr_max - 1) - this.yearRangeStart + 1;
            }

            if (konfig.dateneingabe_form_jahr_bis && +konfig.dateneingabe_form_jahr_bis > 1900) {
                jahr_bis = konfig.dateneingabe_form_jahr_bis;
            } else {
                jahr_bis = (jahr_max - 1);
            }

            // WKETOOL-93 - 447: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
            // if (jahr_von < jahr_min) {
            //     jahr_von = jahr_min;
            // }
            if (jahr_von < 2010) {
                jahr_von = 2010;
            }

            // console.log('Jahre', jahr_von, jahr_bis, konfig);
        }
        this.state = {
            konfig,
            jahr_von,
            jahr_bis,
            jahr_min,
            jahr_max,
            entities: undefined,
            loadingDone: false,
            doRenderForm: {},
            extraForms: {},
            dataForOptionalDialog: undefined,
            dataForOptionalDialog2: undefined,
            showBereiche: this.contextService.get('energieDatenKomplexBereiche') || { 'klimagase': true },
            eigenstrom_typen_s: [],
            eigenwaerme_typen_w: [],
            currentYear: undefined,
            presetFormConfig: {},
            forceNoRenderOnce: false,
            jahrForScope3Auswahl: null,
            validation: {},
            mouseOverHinweise: undefined,
            erfassungsmodus: null,
            activeFormKey: null
        };
        this.onChange = this.onChange.bind(this);
        this.saveForms = this.saveForms.bind(this);
        this.setJahrBis = this.setJahrBis.bind(this);
        this.setJahrVon = this.setJahrVon.bind(this);
        this.getFormFunktionBtn = this.getFormFunktionBtn.bind(this);
        this.forceRerenderForm = this.forceRerenderForm.bind(this);
        this.reloadBundle = this.reloadBundle.bind(this);
        this.saveJahre = this.saveJahre.bind(this);
        this.reloadRerenderForm = this.reloadRerenderForm.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.delFormData = this.delFormData.bind(this);
        this.onValidate = this.onValidate.bind(this);
        this.renderBtnDetailierteErfassung = this.renderBtnDetailierteErfassung.bind(this);
        this.getFormExtraElement = this.getFormExtraElement.bind(this);

        // const urlParams = new URLSearchParams(window.location.search);
        // this.enableFormShowMode = urlParams.get('enableFormShowMode') == '1' || urlParams.get('enableFormShowMode') == 'true';
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private enableFormShowMode = true;
    private baseWidth = 220;
    private labelWidthExt = 50;
    private yearRangeStart = 1;
    private yearRange = 6;
    private dataTemp: any = {};
    private standortTids: number[] = [];
    private saveHandleId: number;
    private savedEntities: any = {};
    private currentFormTarget: any;
    private tempCustomFormConfig: any = {};
    private lastScope3Structure: any[] = [];

    componentDidMount(): void {
        const routing: any = this.props.routing || {};
        this.standortTids = (getStandorte(this.props.data) || []).map((standort: any) => standort.tid);
        if (routing.entities && Array.isArray(routing.entities)) {
            const bereiche: any = {};
            routing.entities.map((entity: string) => { bereiche[entity] = true; });
            this.setState({ showBereiche: bereiche });
        }
        this.initValidierung();
    }

    componentWillUnmount() {
        // Es kann sein, dass noch eine Funktion in setTimeout wartet.
        if (this.saveHandleId) {
            this.saveForms();
        }
        // console.log('componentWillUnmount -> Reload', this.savedEntities);
        Object.keys(this.savedEntities).forEach((ent: string) => this.triggerService.fire('reload', ent));
    }

    componentDidUpdate(prevProps: Readonly<DateneingabeCO2KomplexProps>, prevState: Readonly<DateneingabeCO2KomplexState>, snapshot?: any): void {
        const scope3Structure = this.getScope3Structure();
        if (this.lastScope3Structure.map((s: any) => s.key).sort().join() !== scope3Structure.map((s: any) => s.key).sort().join()) {
            this.lastScope3Structure = scope3Structure;
            this.initEntities();
        }
        if ((this.props.standortSelected || {}).tid !== (prevProps.standortSelected || {}).tid) {
            this.initValidierung();
        }
        // Object.keys(this.savedEntities).forEach((ent: string) => {
        //     this.triggerService.fire('reload', ent);
        //     delete this.savedEntities[ent];
        // });

        // WKETOOL-213: Zeilen ohne Eingabefelder in der Tapete ausblenden
        if (this.state.loadingDone) {
            hideKomplexRows(`CO2Komplex_${this.props.standortSelected.tid}`);
        }
    }

    getScope3Structure() {
        const bereichKey = this.apiService.getBereichKey();
        const data: any = this.props.data || {};
        const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];
        const modul: string = data.MODUL_SELECTED || null;
        return [
            ...getCO2Scope3StructureVorgelagert(bereichKey, modul),
            ...filterCO2Scope3StructureNachgelagert(getCO2Scope3StructureNachgelagert(bereichKey, modul), konfiguration),
            ...getCO2Scope3StructureAllgemein()
        ];
    }

    initEntities() {
        const entities: any[] = [];
        const scope3Structure = this.getScope3Structure();
        scope3Structure.forEach((s: any) => {
            const entity: string = s.key === IDs.ENT_ENERGIEDATEN_WASSER ? IDs.ENT_ENERGIEDATEN_WASSER : `co2_scope3_${s.key}`;
            entities.push({
                titel: s.name, entity, ...(s.ignore && { onlyHinweis: 'Berechnung erfolgt automatisch' }),
                route: RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS
            });
        });
        // Jetzt die Entities wg. den Bundles laden
        const load_goal = entities.length;
        let load_cnt = 0;
        entities.forEach((entity: any) => {
            if (entity.onlyHinweis) {
                load_cnt++;
                if (load_goal === load_cnt) {
                    this.setState({ loadingDone: true, entities });
                }
            }
            this.dataService.loadDataForModul(entity.entity, { tid: -1 }, { bundle: true }, IDs.MOD_ETOOL,
                (result: any) => {
                    if (result) {
                        entity.bundle = result.bundle;
                    }
                    load_cnt++;
                    if (entity.entity === IDs.ENT_KLIMAGASE) {
                        entity.bundle.art_tid = this.props.data[IDs.ENT_KLIMAGASE_ART] || [];
                    } else if (entity.entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
                        entity.bundle.art_tid = this.props.data[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL] || [];
                    }
                    if (load_goal === load_cnt) {
                        this.setState({ loadingDone: true, entities });
                    }
                }
            );
        });
        return entities;
    }

    initValidierung(): void {
        const standortTid: number = this.props.standortSelected.tid || null;
        const entities: Array<any> = this.initEntities();
        this.setState({
            validation: new Validierung(
                this.props.data,
                standortTid,
                entities,
                'jahr'
            ).getData()
        });
    }

    findFotoFields() {
        // ZU TESTEN
        const struct_tool = new StructureTool(IDs.MOD_ETOOL);
        const strucAll = struct_tool.getStructureAllByModul(IDs.MOD_ETOOL);
        if (strucAll) {
            const fnd: any = {};
            Object.keys(strucAll).forEach((ent: string) => {
                if (Array.isArray(strucAll[ent].ATTS)) {
                    const fields = strucAll[ent].ATTS.filter((a: any) => a.TYPE === 'FILE');
                    if (fields.length > 0) {
                        fnd[ent] = fields;
                    }
                }
            });
            // console.log(fnd);
            // console.log(JSON.stringify(fnd));
        }
    }

    forceRerenderForm(key: string) {
        // key ist entityName oder formKey
        const { doRenderForm } = this.state;
        doRenderForm[key] = false;
        this.setState({ doRenderForm }, () => {
            doRenderForm[key] = true;
            this.setState({ doRenderForm }, () => {
                setTimeout(() => this.setFocusOnInput(), 0);
            });
        });
    }

    getMaxRowCnt(dataRows: any, jahr_von: number, jahr_bis: number) {
        const map: any = {};
        for (let j = jahr_von; j <= jahr_bis; j++) {
            if (!map[j]) {
                map[j] = 0;
            }
        }
        dataRows.forEach((r: any) => {
            if (typeof r.jahr === 'number' && r.jahr > 0 && typeof map[r.jahr] === 'number') {
                // Nach dem 1. Round haben DS "_formKey"
                if (!r._formKey || r._formKey.endsWith('_X') /* DS nicht aus extra Zeilen */) {
                    map[r.jahr]++;
                }
            }
        });
        // console.log(map);
        return Math.max(1, ...Object.keys(map).map((j: string) => map[j]));
    }

    getDisableFieldSelectDefaultOptions(entity: string) {
        switch (entity) {
            case IDs.ENT_CO2_SCOPE3_PENDELN:
            // no break
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                return {
                    art: true,
                    teilstrecken: true,
                    ubernachtungen: true
                };
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                return {
                    teilstrecken: true,
                    ubernachtungen: true
                };
            case IDs.ENT_CO2_SCOPE3_REISEN:
                return {
                    firmenfahrzeug: true,
                    teilstrecken: true
                };
            default: return {};
        }
    }

    getFormFunktionBtn(isFirst: boolean, entity: any, values: any, showMode?: boolean) {
        const headerLabel = 'Funktionen';
        const label = 'Datensatz löschen';
        const label2 = 'Datensatz entleeren';
        const btnKey = (values._formKey ? values._formKey : 'form') + '_btn_delete';
        const btnKey2 = (values._formKey ? values._formKey : 'form') + '_btn_empty';
        const showDelBtn = values.tid > 0 ? true : false;
        const helpIcon: JSX.Element = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ marginRight: 10 }}
            styleProps={{ margin: 0 }}
            label={`Info "${headerLabel}"`}
            helpKey={`${IDs.MOD_ETOOL}_dateneingabe_funktionen`}
            type='theme_info'
            style='theme_small'
            editBar
            useTheme
        />;

        if (!this.state.loadingDone || showMode || this.saveHandleId) {
            const showInfo = this.saveHandleId && !showMode ? <div style={{ fontStyle: 'italic', marginTop: 3 }}>Datensatz wird gespeichert.</div> : '';
            return <div className={formStyle.fieldBox}>
                {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
                <div className={formStyle.input}>{showInfo}</div>
            </div>;
        }

        // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
        const enableRfg = true;
        const hasActivatedRfg = hasEntityActivatedRfg(entity.entity, this.props.data);
        const isEMIEJMAED = gibtEMIEJMAED(this.props.data[entity.entity] || [], values.jahr, values.jahr, this.props.standortSelected.tid);
        const showEmptyBtn = enableRfg && hasActivatedRfg && isEMIEJMAED && values.tid > 0;
        const entName = entity.entity;
        const onRfgChange = (dataItem1: any, dataItem2: any) => {
            // console.log(dataItem1, dataItem2);
            const items = [{ tid: dataItem1.tid, rfg: dataItem1.rfg }, { tid: dataItem2.tid, rfg: dataItem2.rfg }];
            this.setState({ loadingDone: false }, () => {
                this.dataService.saveDataList(entName, items, (sqlSuc: string, suc: boolean) => {
                    this.setState({ loadingDone: true });
                    if (suc) {
                        console.log('rerender', 'onRfgChange', entName);
                        this.forceRerenderForm(entName);
                    }
                }, IDs.MOD_ETOOL);
            });
        };

        return <div className={formStyle.fieldBox}>
            {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
            <div className={formStyle.input} style={{ display: 'flex' }}>
                {showEmptyBtn && <div style={{ flex: 1 }}>
                    {getFormRfgBtns(entName, values, this.props.data, onRfgChange)}
                </div>}
                {showEmptyBtn && <div style={{ flex: 1 }}>
                    <WActionButton
                        styleProps={{ height: 20, margin: 0, width: 'calc(100% - 8px)' }}
                        label={label2}
                        // insideText={label2}
                        tooltip={label2}
                        key={btnKey2}
                        action='delete'
                        onAction={() => {
                            if (window.confirm('Datensatz wirklich entleeren?')) {
                                this.emptyFormData(entity, values);
                            }
                        }}
                    />
                </div>}
                {showDelBtn && <div style={{ flex: 1 }}>
                    <WActionButton
                        styleProps={{ height: 20, margin: 0, width: 'calc(100% - 8px)' }}
                        label={label}
                        insideText={showEmptyBtn ? null : label}
                        tooltip={label}
                        key={btnKey}
                        action='delete2'
                        onAction={() => {
                            if (window.confirm('Datensatz wirklich löschen?')) {
                                this.delFormData(entity, values);
                            }
                        }}
                    />
                </div>}
            </div>
        </div>;
    }

    onDeleteDone(entName: string, consoleInfo?: string) {
        // 1. postProcess
        processKennziffernBerechnung(this.props.data);
        // 2. forceRerenderForm
        console.log('rerender', consoleInfo, entName);
        this.forceRerenderForm(entName);
    }

    emptyFormData(entity: any, row: any) {
        if (row.tid > 0) {
            const { data } = this.props;
            const entName = entity.entity;
            // Datensatz entleeren
            const rowIdx = data[entName].findIndex((r: any) => r.tid === row.tid);
            const emptyData = { ...row };
            const reservedFields: Array<string> = ['tid', 'rfg', '_formKey', 'standort_tid', 'standort_tid_orig', 'jahr', 'abrechnungszeitraum_von', 'abrechnungszeitraum_bis'];
            Object.keys(emptyData).forEach((k: string) => {
                if (reservedFields.indexOf(k) === -1) {
                    emptyData[k] = null;
                }
            });
            data[entName][rowIdx] = emptyData;
            this.dataService.saveData(entName, emptyData, null, null, (suc: boolean) => {
                if (suc) {
                    this.savedEntities[entName] = true;
                    const childRows = data[entName].filter((r: any) => r.parent_tid === row.tid);
                    let cnt = childRows.length;
                    const emptyDone = () => {
                        this.onDeleteDone(entName, 'emptyFormData');
                    };
                    if (cnt > 0) {
                        childRows.forEach((f: any) => {
                            this.dataService.delData(entName, IDs.MOD_ETOOL, { tid: f.tid }, {}, () => {
                                cnt--;
                                if (cnt === 0) {
                                    emptyDone();
                                }
                            });
                        });
                    } else {
                        emptyDone();
                    }
                }
            }, IDs.MOD_ETOOL);
        }
    }

    delFormData(entity: any, row: any) {
        const { data } = this.props;
        const entName = entity.entity;
        const fndRows = data[entName].filter((r: any) => r.tid === row.tid || (r.parent_tid > 0 && r.parent_tid === row.tid));
        let cnt = fndRows.length;
        if (cnt > 0) {
            this.savedEntities[entName] = true;
            fndRows.forEach((f: any) => {
                this.dataService.delData(entName, IDs.MOD_ETOOL, { tid: f.tid }, {}, () => {
                    const idx = data[entName].findIndex((r: any) => r.tid === f.tid);
                    const validation: any = this.state.validation || {};
                    if (Object.keys(((validation[f.jahr || null] || {})[entName] || {})[f.tid] || {}).length) {
                        delete validation[f.jahr][entName][f.tid];
                        this.setState({ validation });
                    }
                    if (idx >= 0) {
                        data[entName].splice(idx, 1);
                    }
                    cnt--;
                    if (cnt === 0) {
                        // Der alte _formKey kann nun einen falschen Datensatz verweisen.
                        // Hier werden _formKey von dem ganzen Entity gelöscht, damit sie bei renderFormRows() erneuert generiert werden.
                        data[entName].forEach((r: any) => delete r._formKey);
                        this.onDeleteDone(entName, 'delFormData');
                    }
                });
            });
        }
    }

    onChange(entityName: string, data: any, callback?: () => void, timeout?: number, field?: any) {
        // console.log('onChange', entityName, data, this.dataTemp[entityName]);
        if (!this.dataTemp[entityName]) {
            this.dataTemp[entityName] = {};
        }
        const formKey = data._formKey;
        this.dataTemp[entityName][formKey] = data;

        // Automatische Speicherung. Wir speichern nach einer kurzen Pause
        const autoSaveIntervall = getAutoSaveIntervall(this.props.data[IDs.ENT_KONFIGURATION]);
        let waitTime = (typeof timeout === 'number' && timeout >= 0) ? timeout : autoSaveIntervall;

        // Änderungen an Auswahl und Datum-Feldern
        if (field && field.typ && ['select', 'datepicker'].indexOf(field.typ) !== -1) {
            // speichern wir sofort.
            waitTime = 0;
            // wenn es Config-Änderungen gibt.
            if (this.diffCustomFormConfig(entityName, data)) {
                // rerendern sofort.
                this.forceRerenderForm(formKey);
            }
        }

        const saveHandleId = window.setTimeout(() => {
            console.log('*** Automatische Speicherung beginnt ... ***');
            this.saveForms();
            this.saveHandleId = null;
        }, waitTime);
        clearTimeout(this.saveHandleId);
        this.saveHandleId = saveHandleId;
    }

    onValidate(data: any): void {
        const entity: string = data.entity || null;
        const fields: any = data.fields || {};
        const jahr: number = +data.jahr || null;
        const tid: number = +data.tid || null;
        const validation: any = this.state.validation || {};

        if (!jahr || !entity || !tid || !Object.keys(fields).length) {
            return;
        }

        if (!validation[jahr]) {
            validation[jahr] = { [entity]: {} };
        }

        if (!validation[jahr][entity]) {
            validation[jahr][entity] = {};
        }

        if (!validation[jahr][entity][tid]) {
            validation[jahr][entity][tid] = {};
        }
        validation[jahr][entity][tid] = fields;
        this.setState({ validation });
    }

    diffCustomFormConfig(entityName: string, data: any) {
        const formKey = data._formKey;
        const cfOld = this.tempCustomFormConfig[formKey];
        const cfNew = getCustomFormConfig(entityName, data, this.props.data);
        // console.log(entityName, data, cfOld, cfNew);
        if (JSON.stringify(cfOld) !== JSON.stringify(cfNew)) {
            this.tempCustomFormConfig[formKey] = cfNew;
            return true;
        }
        return false;
    }

    setFocusOnInput() {
        // Den Eingabefeld wieder fokussieren.
        if (this.currentFormTarget) {
            const tag = this.currentFormTarget.tagName;
            const id = this.currentFormTarget.id;
            let ele;
            if (tag === 'INPUT') {
                ele = document.getElementById(id) as HTMLInputElement;
            } else if (tag === 'TEXTAREA') {
                ele = document.getElementById(id) as HTMLTextAreaElement;
            }
            // console.log(id, ele);
            if (ele) {
                ele.focus();
                const val = ele.value;
                ele.value = '';
                ele.value = val;
            }
        }
    }

    reloadBundle(entity: string) {
        const { entities } = this.state;
        if (Array.isArray(entities)) {
            const strom = entities.find((e: any) => e.entity === entity);

            if (strom) {
                this.dataService.loadDataForModul(entity, { tid: -1 }, { bundle: true }, IDs.MOD_ETOOL,
                    (result: any) => {
                        if (result) {
                            strom.bundle = result.bundle;
                        }
                        // console.log(entity,entities);
                        this.setState({ entities });
                    }
                );
            }
        }
    }

    reloadData(entity: string, callback?: () => void) {
        const { data } = this.props;
        this.dataService.loadData(entity, {}, { resolve: true }, (res: any) => {
            if (Array.isArray(res[entity])) {
                if (!data[entity]) {
                    data[entity] = [];
                }
                // Sind Datensätze am Server entfernt, entfernen wir die lokalen auch.
                // Array.length bzw. index hat sich inzwischen geändert!
                const delTids = data[entity].filter((r: any) => r.parent_tid > 0 && !res[entity].find((d: any) => d.tid === r.tid)).map((r: any) => r.tid);
                delTids.forEach((tid: number) => {
                    const idx = data[entity].findIndex((r: any) => r.tid === tid);
                    data[entity].splice(idx, 1);
                });
                // Aktualisieren die lokalen Datensätze
                res[entity].forEach((r: any) => {
                    if (r.parent_tid > 0) {
                        const idx = data[entity].findIndex((d: any) => d.tid === r.tid);
                        if (idx >= 0) {
                            data[entity][idx] = r;
                        } else {
                            data[entity].push(r);
                        }
                    }
                });
                // console.log(entity, res[entity], data[entity]);
            }
            if (callback) {
                callback();
            }
        }, IDs.MOD_ETOOL);
    }

    reloadRerenderForm(entity: string, values: any, formKey: string, callback?: () => void) {
        const { data } = this.props;
        console.log('reloadRerenderForm', formKey, values.tid);
        this.dataService.loadData(entity, { tid: values.tid }, { resolve: true }, (res: any) => {
            if (Array.isArray(res[entity]) && res[entity].length > 0 && Array.isArray(data[entity])) {
                const row = res[entity][0];
                const idx = data[entity].findIndex((r: any) => r.tid === row.tid);
                if (formKey) {
                    row._formKey = formKey;
                }
                if (idx >= 0) {
                    data[entity][idx] = row;
                } else {
                    data[entity].push(row);
                }
                processKennziffernBerechnung(this.props.data);
                // 1. Rfg
                const didRerender = this.hasRfgChanged(entity, values);
                // 2. forceRerenderForm
                if (!didRerender && formKey) {
                    console.log('rerender', 'reloadRerenderForm', formKey);
                    this.forceRerenderForm(formKey);
                }
            }
            if (callback) {
                callback();
            }
            this.setFocusOnInput();
        }, IDs.MOD_ETOOL);
    }

    hasRfgChanged(entity: string, values: any) {
        const hasActivatedRfg = hasEntityActivatedRfg(entity, this.props.data);
        if (hasActivatedRfg && values) {
            const { data } = this.props;
            const fnd = data[entity].find((r: any) => r.tid === values.tid);
            if (fnd && fnd.rfg && values.rfg && fnd.rfg !== values.rfg) {
                // Entferne _formKey, um neue Sortierung zu erstellen.
                // Temp. Datensatz hat standort_tid statt standort_tid_orig
                data[entity].filter((r: any) => r.standort_tid_orig === (values.standort_tid_orig || values.standort_tid) && r.jahr === values.jahr)
                    .forEach((r: any) => delete (r._formKey));
                console.log('rerender', 'hasRfgChanged', entity);
                this.forceRerenderForm(entity);
                return true;
            }
        }
        return false;
    }

    render(): JSX.Element {
        const gewerk = getGewerk(this.props.data);

        if (!gewerk) {
            return (
                <div style={{ padding: 10 }}>
                    <br /><br />
                    Dieser Bereich steht aktuell noch nicht zur Verfügung,
                    bitte konfigurieren Sie zunächst ein Gewerk im Bereich Dateneingabe/Betriebliche Daten/Unternehmensdaten!
                </div>
            );
        }

        if (this.state.forceNoRenderOnce) {
            window.setTimeout(() => this.setState({ forceNoRenderOnce: false }), 500);
            return <WSpinner />;
        }

        const jahr_von = this.state.jahr_von;
        const jahr_bis = this.state.jahr_bis;
        const entities = this.state.entities;
        const showAllCheckBox = <div style={{ display: 'flex', marginLeft: -4, marginTop: 5 }}>
            <div key={'show_all_box'} style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <input
                    type='checkbox'
                    checked={this.state.showBereiche['showAll'] || false}
                    onChange={(evt: any) => {
                        const showBereiche = this.state.showBereiche;
                        showBereiche['showAll'] = evt.target.checked;
                        this.setState({ showBereiche });
                    }}
                />&nbsp;
                <small><i>Alle Bereiche anzeigen</i></small>
            </div>
            {this.renderBtnDetailierteErfassung()}
        </div>;
        const scope3Auswahl = getCO2Scope3Auswahl(this.props.data, this.props.standortSelected, this.state.jahr_von, this.state.jahr_bis);
        const hasEmittenten: boolean = (this.props.data || {})[IDs.ENT_CO2_SCOPE3_EMITTENTEN].some((emittent: any) =>
            emittent.jahr >= this.state.jahr_von && emittent.jahr <= this.state.jahr_bis
            && (emittent.standort_tid_orig || emittent.standort_tid) === this.props.standortSelected.tid
        );
        // console.log('SCOPE3 Auswahl: ', scope3Auswahl, entities);
        return <>
            <div
                className={formStyle.formCompact}
                style={{
                    position: 'fixed', zIndex: 2, width: '100%', backgroundColor: '#eee', borderBottom: '2px solid #eee',
                    ...(this.props.style || {})
                }}
            >
                <div style={{ backgroundColor: 'white', right: 0, width: 20, height: 71, position: 'fixed' }} />
                <DatenauswertungJahrauswahl
                    // WKETOOL-93 - 447: Das Jahr der Eingabe darf kleiner als das Startjahr sein.
                    jahrMin={this.state.jahr_min}
                    // jahrMin={2010}
                    jahrMax={this.state.jahr_max}
                    jahrFirst={this.state.jahr_von}
                    jahrLast={this.state.jahr_bis}
                    onFirstJahrChange={(jahr: number) => this.setJahrVon(+jahr)}
                    onLastJahrChange={(jahr: number) => this.setJahrBis(+jahr)}
                    externalHeaderElements={[showAllCheckBox]}
                />
                {this.renderJahre({ titel: '', entity: 'jahre' }, jahr_von, jahr_bis, true)}
            </div>
            <div
                style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
                onClick={(event: any) => this.currentFormTarget = event.target}
                onChange={(event: any) => this.currentFormTarget = event.target}
                ref={(ref: any) => this.setLoaderStyle(ref)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 70, overflow: 'auto' }}>
                    {entities && entities
                        .filter((e: any) => scope3Auswahl.some((s: string) =>
                            s === e.entity.replace('co2_scope3_', '')
                            && (s !== 'emittenten' || hasEmittenten)
                        ))
                        .map((e: any, idx: number) =>
                            <React.Fragment key={`entity-${idx}`}>
                                {this.renderEntity(e, jahr_von, jahr_bis)}
                            </React.Fragment>
                        )}
                </div>
                {this.state.jahrForScope3Auswahl > 0 && this.renderAuswahlDialog()}
                {!this.state.loadingDone && <WSpinner />}
            </div>
        </>;
    }

    renderBtnDetailierteErfassung(onWillChange?: () => void) {
        const { erfassungsmodus } = this.state;
        // return <DetaillierteErfassungScope3
        //     data={this.props.data}
        //     isChecked={cbDetailierteErfassung}
        //     onWillChange={onWillChange}
        //     onChange={(isChecked: boolean) => {
        //         this.setState({ cbDetailierteErfassung: isChecked, loadingDone: false }, () => {
        //             const { showBereiche } = this.state;
        //             this.setState({ showBereiche: {} }, () => this.setState({ showBereiche, loadingDone: true }));
        //         });
        //     }}
        // />;
        return <AuswahlErfassungsmodus
            data={this.props.data}
            // layout={'sidebysideComplexGreen'}
            erfassungsmodus={erfassungsmodus}
            onWillChange={onWillChange}
            onChange={(erfassungsmodus: string) => {
                this.setState({ erfassungsmodus, loadingDone: false }, () => {
                    const { showBereiche } = this.state;
                    this.setState(
                        { showBereiche: {} },
                        () => this.setState({ showBereiche, loadingDone: true }, this.initValidierung)
                    );
                });
            }}
        />;
    }

    renderAusklappen(entity: any) {
        return (
            <div
                style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', padding: 5 }}
                onClick={() => {
                    const showBereiche = this.state.showBereiche;
                    showBereiche[entity.entity] = true;
                    // console.log(showBereiche);
                    this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
                }}
            >
                &#9654; &nbsp;<i>Dateneingabe öffnen</i>
            </div>
        );
    }

    renderAuswertungButton(route: any): JSX.Element {
        // const standortTabId: number = this.standortTids.indexOf(this.props.standortSelected.tid || null);
        // if (!route || standortTabId === -1) {
        //     return;
        // }
        // const standorte: any[] = getStandorte(this.props.data) || [];
        // const path: any = { ...route, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: standortTabId + (standorte.length > 1 ? 2 : 1) };

        const data: any = this.props.data || {};
        const standort: any = this.props.standortSelected || {};
        if (!route || !standort.tid) {
            return;
        }

        // Tab-Routing
        let tabRouting: any = {};
        const istVeranstaltung = standort.standort_typ_tid_orig === 5 || standort.standort_typ_tid_orig === 6;
        if (!istVeranstaltung) {
            const standortRoutingFnd = findStandorteTabRouting(standort.tid, data, RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE, RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE, 2) || {};
            tabRouting = {
                path: standortRoutingFnd.path
            };
        } else {
            const basisRouting = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
            const basisTab = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
            const datenauswertungTabs = [
                { name: 'Energie-Cockpit' },
                { name: 'Gesamtunternehmen' },
                ...getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2)
            ];
            tabRouting = {
                path: {
                    ...basisRouting,
                    [basisTab]: datenauswertungTabs.length,
                    terminateOn: basisTab
                }
            };
        }
        tabRouting.path = { ...tabRouting.path, [RoutingIDs.TABS_DATENAUSWERTUNG]: route[RoutingIDs.TABS_DATENAUSWERTUNG] };

        return (
            <WActionButton
                label='Zur Auswertung'
                insideText='Zur Auswertung'
                // styleProps={{ color: 'white', backgroundColor: '#00b050' }}
                tooltip='Zum Datenauswertungsbereich springen'
                key='auswertung'
                action='view'
                onAction={() => this.props.onRoutingChange({ ...tabRouting, ...(standort && { standort: standort.tid }) })}
            />
        );
    }

    renderBtnNeuerDS(entity: any) {
        const key = entity.entity;
        if (key === IDs.ENT_KLIMAGASE || true) { // Erstmal alle!
            let insideText = `Leere Zeile für ${entity.titel} einfügen`;
            switch (key) {
                case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
                    insideText = 'Weitere Güter erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
                    insideText = 'Weitere Kapitalgüter erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                    insideText = 'Weitere Transporte erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_ABFALL:
                    insideText = 'Weitere Abfälle erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_REISEN:
                    insideText = 'Weitere ' + i18n2('Geschäftsreisen') + ' erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_PENDELN:
                    insideText = 'Weitere Arbeitnehmer:innen erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                    insideText = 'Weitere Transporte erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:
                case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:
                case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG:
                case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS:
                case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:
                case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN:
                case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE:
                case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK:
                case IDs.ENT_CO2_SCOPE3_FRANCHISE:
                case IDs.ENT_CO2_SCOPE3_INVESTITION:
                    insideText = 'Weiteren Datensatz für die Kategorie erfassen';
                    break;
                case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
                    insideText = 'Weitere Emissionsquellen erfassen';
                    break;
                case IDs.ENT_KLIMAGASE:
                    insideText = 'Weitere klimawirksame Gase hinzufügen';
                    break;
            }
            return (
                <div style={{ textAlign: 'left', marginTop: 5, marginBottom: 5, marginLeft: this.props.scrollLeft || 0 }}>
                    <WActionButton
                        tooltip={insideText}
                        label={insideText}
                        action='add'
                        // styleProps={{ color: 'white', backgroundColor: '#00b050' }}
                        insideText={insideText}
                        key='btn_neuer_datensatz'
                        onAction={() => {
                            const { extraForms } = this.state;
                            extraForms[key] = extraForms[key] > 0 ? extraForms[key] : 0;
                            extraForms[key]++;
                            this.setState({ extraForms });
                        }}
                    />
                </div>
            );
        } else {
            return <div style={{ textAlign: 'left', marginTop: 5, marginBottom: 5, marginLeft: this.props.scrollLeft || 0 }} />;
        }
    }

    renderAuswahlDialog() {
        return (
            <div>
                <DialogWrapper2
                    title={'Scope 3 Kategorien: Prüfung der Wesentlichkeit'}
                    width={-1}
                    onAfterClose={() => this.setState({ jahrForScope3Auswahl: null }, this.initValidierung)}
                >
                    <div style={{ overflowY: 'auto' }}>
                        <DateneingabeCO2Scope3Auswahl
                            noTitle
                            data={this.props.data}
                            standortSelected={this.props.standortSelected}
                            jahrFix={this.state.jahrForScope3Auswahl}
                            onClose={() => this.setState({ jahrForScope3Auswahl: null }, this.initValidierung)}
                        />
                    </div>
                </DialogWrapper2>
            </div>
        );
    }

    renderEinklappen(entity: any) {
        return (
            <div
                style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', display: 'inline', padding: 5 }}
                onClick={() => {
                    const showBereiche = this.state.showBereiche;
                    delete (showBereiche[entity.entity]);
                    // console.log(showBereiche);
                    this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
                }}
            >
                &#9660; &nbsp;<i>Dateneingabe schließen</i>
            </div>
        );
    }

    renderEntity(entity: any, jahr_von: number, jahr_bis: number) {
        const { extraForms } = this.state;
        const key = entity.entity;

        const { data } = this.props;
        const forms: Array<JSX.Element> = [];
        if (!entity.onlyHinweis) {
            let dataRows: Array<any> = Array.isArray(data[key]) ? data[key] : [];
            dataRows = dataRows.filter((r: any) => r.standort_tid_orig === this.props.standortSelected.tid && (+r.parent_tid || 0) === 0);
            // console.log('EntityRows', entity, dataRows);
            let rowCnt = 1;

            // WKETOOL-133 Datensatz-Sortierung
            dataRows = sortKomplexDataRows(key, dataRows, data, jahr_von, jahr_bis);

            if (key === IDs.ENT_KLIMAGASE || key === IDs.ENT_KLIMAGASE_BENUTZER || true) { // Erstmal alle
                rowCnt = this.getMaxRowCnt(dataRows, jahr_von, jahr_bis);
            }

            const extraRowCnt = extraForms[key] > 0 ? extraForms[key] : 0;
            // console.log(key, dataRows, rowCnt, extraRowCnt);

            const hasBtnLeerZeile = key === IDs.ENT_KLIMAGASE || key === IDs.ENT_KLIMAGASE_BENUTZER || true; // Erstmal alle

            const stylrZZ: React.CSSProperties = {
                fontSize: 12, fontWeight: 'bold', padding: '3px 0 3px 5px', color: 'white', backgroundColor: '#616468',
                width: this.baseWidth * (jahr_bis - jahr_von + 2) + (jahr_bis - jahr_von + 1) + this.labelWidthExt
            };

            // Render Forms
            for (let i = 0; i < rowCnt; i++) {
                const rowName = this.renderRowName(entity, entity.titel, i + 1);
                forms.push(
                    <div className={formStyle.formCompact} style={{ marginBottom: 0 }} key={`form_0_${i}`}>
                        {rowCnt + extraRowCnt > 1 &&
                            <div style={stylrZZ}>
                                {hasBtnLeerZeile ? rowName : ''}
                                {/*hasBtnLeerZeile ? (entity.titel + ' ' + (i + 1)) : ''*/}
                            </div>}
                        <div className={formStyle.formCompact} style={{ display: 'flex', flexDirection: 'row' }}>
                            {this.renderFormRows(entity, dataRows, jahr_von, jahr_bis, i)}
                        </div>
                    </div>
                );
            }
            // Render extra Forms
            for (let i = 0; i < extraRowCnt; i++) {
                const rowName = this.renderRowName(entity, entity.titel, rowCnt + i + 1);
                forms.push(
                    <div style={{ marginBottom: 0 }} key={`form_1_${i}`}>
                        {rowCnt + extraRowCnt > 1 &&
                            <div style={stylrZZ}>
                                {hasBtnLeerZeile ? rowName : ''}
                                {/*hasBtnLeerZeile ? (entity.titel + ' ' + (rowCnt + i + 1)) : ''*/}
                            </div>
                        }
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {this.renderFormRows(entity, dataRows, jahr_von, jahr_bis, null, i)}
                        </div>
                    </div>
                );
            }
        }

        const showBereich = this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }} key={`ent_${key}`}>
                {this.renderJahre(entity, jahr_von, jahr_bis, false)}
                {showBereich && forms}
                {showBereich && entity.onlyHinweis && this.renderHinweisOnly(entity.onlyHinweis, (jahr_bis - jahr_von) + 1)}
                {!entity.onlyHinweis && showBereich && this.renderBtnNeuerDS(entity)}
            </div>
        );
    }

    renderEntityTitel(entity: any): JSX.Element {
        entity = entity || {};
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const title: string = isOpenable ? 'Dateneingabe öffnen' : (isCloseable ? 'Dateneingabe schließen' : null);
        return (
            <div
                style={{ display: 'flex', alignItems: 'center', cursor: (isCloseable || isOpenable) ? 'pointer' : 'default' }}
                title={title}
                onClick={() => this.toggleShowBereich(entity)}
            >
                {(isCloseable || isOpenable) &&
                    <span style={{ fontSize: 11, fontWeight: 'normal', minWidth: 12, maxWidth: 12 }}>
                        {isOpenable ? <>&#9654;</> : <>&#9660;</>}
                    </span>
                }
                {i18n2(entity.titel)}
            </div>
        );
    }

    renderHinweisOnly(hinweis: string, jahre: number) {
        return <div
            style={{
                backgroundColor: '#eee', color: '#888', padding: 8, paddingLeft: 280, fontSize: 12, width: (201 * jahre + 270),
                boxSizing: 'border-box'
            }}
        >
            <i style={{ marginLeft: this.props.scrollLeft || 0 }}>{hinweis}</i>
        </div>;
    }

    renderFormRows(entity: any, dataRows: any, jahr_von: number, jahr_bis: number, idx?: number, extraIdx?: number) {
        const forms: Array<JSX.Element> = [];
        const bereichKey = this.apiService.getBereichKey();
        // const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        for (let j = jahr_von; j <= jahr_bis; j++) {
            // Prüfen, ob es die Auswahl auch für dieses Jahr gibt ...
            const auswahl_jahr = getCO2Scope3Auswahl(this.props.data, this.props.standortSelected, j, j);
            let formActive = true;
            if (!auswahl_jahr.some((s: string) => s === entity.entity.replace('co2_scope3_', ''))) {
                formActive = false;
            }

            const isFirst = j === jahr_von;
            let rows = dataRows.filter((r: any) => r.jahr === j);
            const formKey = entity.entity === IDs.ENT_ENERGIEDATEN_WASSER
                ? getFormKey(entity.entity, j, idx, extraIdx, null, this.props.standortSelected.tid)
                : getFormKey(entity.entity, j, idx, extraIdx);
            // const formKey = getFormKey(entity.entity, j, idx, extraIdx, '0', this.props.standortSelected.tid);
            // const formKey = getFormKey(entity.entity, j, idx, extraIdx);
            // const formKey2 = entity.entity + '_' + j + '_' + (typeof idx === 'number' && idx >= 0 ? idx : 'X') + '_' +
            //     (typeof extraIdx === 'number' && extraIdx >= 0 ? extraIdx : 'X');
            // console.log(formKey === formKey2, formKey, formKey2);

            let data: any = null;
            const fndByFormKey = rows.find((r: any) => r._formKey === formKey);
            // console.log(formKey, idx, dataRows, fndByFormKey);

            // Passt der FormKey, gehört der DS dem Formula.
            if (fndByFormKey) {
                data = fndByFormKey;
            } else {
                // Nach dem 1. Round haben DS "_formKey"
                const len1 = rows.length;
                rows = rows.filter((r: any) => !r._formKey);
                const len2 = rows.length;
                // Wir berechnen Offset, da DS mit formKey schon eingesetzt wurden.
                const offs = len1 - len2;

                if (idx >= 0) {
                    data = rows[idx - offs];
                }

                // formkey in den ursprünglichen DS schreiben
                if (!data) {
                    data = { _formKey: formKey };
                    // Vorbelegung der neuen Daten
                    this.setDataPreset(entity.entity, data);
                } else {
                    data._formKey = formKey;
                }
            }

            if (this.dataTemp[entity.entity] && this.dataTemp[entity.entity][formKey]) {
                data = this.dataTemp[entity.entity][formKey];
            }

            const { doRenderForm } = this.state;
            const customFormConfig = getCustomFormConfig(entity.entity, data, this.props.data);
            recordHiddenRows(`CO2Komplex_${this.props.standortSelected.tid}`, formKey, customFormConfig, jahr_von, jahr_bis, j, entity.entity, formActive);

            const form = <div
                onMouseEnter={(evt) => this.onMouseEnter(evt, formKey)}
                onMouseOver={(evt) => this.onMouseEnter(evt, formKey)}
                ref={(ref: any) => this.setFormStyle(ref, isFirst)}
            >
                <DateneingabeCO2KomplexForm
                    showMode={this.enableFormShowMode && this.state.activeFormKey !== formKey}
                    WFormId={formKey}
                    key={`${formKey}${doRenderForm[entity.entity] === false || doRenderForm[formKey] === false ? '_tmp' : ''}`}
                    layout='sidebysideComplex'
                    // layout='sidebysideComplexGreen'
                    formKey={formKey}
                    entity={entity}
                    isFirst={isFirst}
                    hideAllFields={!formActive}
                    jahr={j}
                    presetFormConfig={this.state.presetFormConfig[entity.entity]}
                    customFormConfig={customFormConfig}
                    disableFieldSelectDefaultOptions={this.getDisableFieldSelectDefaultOptions(entity.entity)}
                    dataItem={data}
                    data={this.props.data}
                    standort={this.props.standortSelected}
                    onChange={this.onChange}
                    getFunktionBtn={this.getFormFunktionBtn}
                    currentYear={this.state.currentYear}
                    posFieldsHelpBeginning={true}
                    onCurrentYearChange={(year: number) => this.setState({ currentYear: year })}
                    // customOnSaveDone={customOnSaveDone}
                    // customOnDelDone={customOnDelDone}
                    reloadBundle={() => this.reloadBundle(entity.entity)}
                    reloadData={this.reloadData}
                    customCssStyle={{
                        // Layout-Problem (calc() Fehler) nur mit FF 78 ESR, hier eine temporäre Lösung
                        ...([IDs.ENT_CO2_SCOPE3_PENDELN, IDs.ENT_CO2_SCOPE3_REISEN, IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT]
                            .indexOf(entity.entity) !== -1
                            ? { formField: { entfernung: { input: { width: 144 } } } }
                            : {}
                        ),
                        ...([IDs.ENT_CO2_SCOPE3_EMITTENTEN]
                            .indexOf(entity.entity) !== -1
                            ? { formField: { emissionsangabe: { height: 50 } } }
                            : {}
                        ),
                        ...(entity.entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF
                            ? {
                                formFieldSelect: {
                                    classOption: {
                                        '-2': { fontStyle: 'italic', fontWeight: 'bold' },
                                        '-1': { fontStyle: 'italic', fontWeight: 'bold' }
                                    }
                                }
                            }
                            : {}
                        )
                    }}
                    onValidate={this.onValidate}
                    renderBtnDetailierteErfassung={this.renderBtnDetailierteErfassung}
                    getExtraElement={this.getFormExtraElement}
                    onFormChangeInteractive={(formData: WFormData, onValueChange: (name: string, value: any) => void) =>
                        onFormChangeInteractiveCO2(entity.entity, bereichKey, formData, onValueChange)}
                />
            </div>;
            forms.push(form);
        }
        return forms;
    }

    setDataPreset(entity: string, data: any) {
        switch (entity) {
            case IDs.ENT_CO2_SCOPE3_PENDELN:
            // no break
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            // no break
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                data.teilstrecken_orig = 2;
                break;
            case IDs.ENT_CO2_SCOPE3_REISEN:
                data.firmenfahrzeug_orig = 2;
                data.teilstrecken_orig = 2;
                break;
            // case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
            //    data.modus_orig = 'average_data';
            //    break;

        }
    }

    renderJahre(entity: any, jahr_von: number, jahr_bis: number, scroll: boolean) {
        // console.log('Render jahre', jahr_von, jahr_bis);
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        const isFirst: boolean = !(this.state.entities || []).findIndex((item: any) => item.entity === entity.entity);
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const isEMIEJMAED = gibtEMIEJMAED(this.props.data[entity.entity] || [], jahr_von, jahr_bis, this.props.standortSelected.tid);
        const title: string = isOpenable ? 'Dateneingabe öffnen' : (isCloseable ? 'Dateneingabe schließen' : null);
        const st: any = {
            display: 'flex', alignItems: 'center', color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)',
            fontSize: 12, boxSizing: 'border-box', padding: '3px 5px', fontWeight: 'bold', marginRight: 1, width: this.baseWidth,
            minWidth: this.baseWidth
        };
        // if (entity.entity === 'jahre') {
        //     st.textAlign = 'center';
        // }
        const st_button: any = {
            fontSize: 18, textAlign: 'left', boxSizing: 'border-box', paddingLeft: 10, fontWeight: 'bold', marginRight: 1,
            width: this.baseWidth, minWidth: this.baseWidth
        };
        const jahre: Array<JSX.Element> = [];
        jahre.push(
            <div
                style={{
                    ...st, width: this.baseWidth + this.labelWidthExt, minWidth: this.baseWidth + this.labelWidthExt,
                    boxShadow: 'white 1px 0', ...(!scroll && { marginLeft: this.props.scrollLeft || 0, justifyContent: 'space-between' }),
                    zIndex: 1
                }}
                key={`jahr_${entity.entity}_head`}>
                {this.renderEntityTitel(entity)}
                {showBereich && entity.headerElement && <div style={{ width: '100%', textAlign: 'center' }}>{entity.headerElement}</div>}
                {showBereich && entity.entity !== 'jahre' && isEMIEJMAED && <CustomDatensatzRfg
                    data={this.props.data}
                    entity={entity.entity}
                    onChange={() => {
                        // Entferne _formKey, um neue Sortierung zu erstellen.
                        this.props.data[entity.entity].forEach((r: any) => delete (r._formKey));
                        // Entferne extra Zeile
                        const extraForms = this.state.extraForms;
                        delete (extraForms[entity.entity]);
                        this.setState({ extraForms }, () => {
                            console.log('rerender', 'CustomDatensatzRfg', entity.entity);
                            this.forceRerenderForm(entity.entity);
                        });
                    }}
                />}
            </div>
        );

        for (let j = jahr_von; j <= jahr_bis; j++) {
            const isCurrentYear = this.state.currentYear && this.state.currentYear === j;
            // const backgroundColor: string = isCurrentYear ? '#00823b' : '#00b050';
            const backgroundColor: string = isCurrentYear ? 'var(--color-section-table-header-highlight)' : 'var(--color-section-main)';
            const color: string = isCurrentYear ? 'var(--color-button-text)' : 'var(--color-button-text)';
            const hasEmittenten: boolean = (this.props.data || {})[IDs.ENT_CO2_SCOPE3_EMITTENTEN].find((emittent: any) =>
                emittent.jahr === j && (emittent.standort_tid_orig || emittent.standort_tid) === this.props.standortSelected.tid
            );
            const auswahlJahr = getCO2Scope3Auswahl(this.props.data, this.props.standortSelected, j, j);
            const userAuswahlJahr = (auswahlJahr || []).filter((k: string) => (hasEmittenten || k !== 'emittenten') && (isCfm || k !== 'energiedaten_wasser'));
            jahre.push(
                <div
                    style={{
                        ...st, color, backgroundColor, ...((j === jahr_von) && { marginLeft: -this.props.scrollLeft || 0 }),
                        cursor: (isCloseable || isOpenable) ? 'pointer' : 'default'
                    }}
                    key={`jahr_${entity.entity}_${j}`}
                    title={title}
                    onClick={() => this.toggleShowBereich(entity)}
                >
                    {/*entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll && j === jahr_von && this.renderEinklappen(entity)*/}
                    {/*entity.entity !== 'jahre' && !showBereich && j === jahr_von && this.renderAusklappen(entity)*/}
                    {entity.entity === 'jahre' && <span style={{ fontSize: 18 }}>{j}</span>}
                    {entity.entity === 'jahre' &&
                        <button
                            style={{ cursor: 'pointer', border: '1px solid', width: 100, marginLeft: 5 }}
                            onClick={() => this.setState({ jahrForScope3Auswahl: j })}
                        >
                            Auswahl ({userAuswahlJahr.length})
                        </button>
                    }
                    {entity.entity === 'jahre' && j &&
                        <ValidierungHinweise
                            entities={this.state.entities}
                            id={j}
                            layout2
                            showPriorityColors
                            style={{ margin: 'auto 9px auto auto' }}
                            validation={this.state.validation}
                        />
                    }
                </div>
            );
        }
        // Button zur Auswertung
        jahre.push(
            <div style={st_button} key={`jahr_${entity.entity}_ausw`}>
                {entity.route && this.renderAuswertungButton(entity.route)}
            </div>
        );
        return (
            <div
                key={`jahre_${entity.entity}`}
                style={{ display: 'flex', flexDirection: 'row', ...(!isFirst && { marginTop: 2 })/*, marginTop: 2, marginLeft: scroll ? (-1 * this.props.scrollLeft) : 0*/ }}>
                {jahre}
            </div>
        );
    }

    renderRowName(entity: any, name: string, position: number): JSX.Element | string {
        // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
        const enableRfg = true;
        name = i18n2(name);
        return enableRfg
            ? <CustomRowName
                data={this.props.data}
                entity={entity.entity}
                id={`${entity}_${name}_${position}`}
                key={`${entity}_${name}_${position}`}
                name={name}
                position={position}
            />
            : `${name || ''} ${position || ''}`;
    }

    saveForms() {
        const tmp = this.dataTemp;
        let cnt = 0;
        Object.keys(tmp).forEach((ent: string) => {
            this.savedEntities[ent] = true;

            Object.keys(tmp[ent]).forEach((formKey: string) => {
                // console.log('saving ...', formKey);
                const values = tmp[ent][formKey];

                const cntNReload = () => {
                    // console.log('done ...', formKey);
                    cnt--;
                    if (cnt === 0) {
                        console.log('saveForms done all');
                        this.setState({ loadingDone: true });
                    }
                };
                cnt++;
                this.dataService.saveData(ent, values, undefined, false,
                    (success: boolean, saveTid: number) => {
                        // console.log(success, saveTid);
                        if (success) {
                            if ((!values.tid || values.tid === 0) && saveTid > 0) {
                                values.tid = saveTid;
                            }
                            this.reloadRerenderForm(ent, values, formKey, cntNReload);
                        } else {
                            cntNReload();
                        }
                    },
                    IDs.MOD_ETOOL
                );
                delete (tmp[ent][formKey]);
            });
        });

        if (cnt > 0) {
            this.setState({ loadingDone: false });
        }
    }

    saveJahre() {
        const { konfig, jahr_von, jahr_bis } = this.state;
        if (konfig?.tid > 0) {
            const data = {
                tid: konfig.tid,
                dateneingabe_form_jahr_von: jahr_von,
                dateneingabe_form_jahr_bis: jahr_bis
            };
            this.dataService.saveData(IDs.ENT_KONFIGURATION, data, undefined, false,
                (success: boolean, saveTid: number) => {
                    this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
                }, IDs.MOD_ETOOL);
        }
    }

    setFormStyle(ref: any, isFirstYear: boolean): void {
        if (ref === null || !isFirstYear) {
            return;
        }
        const labels: NodeListOf<HTMLElement> = ref.querySelectorAll('div[class^="label"]');
        for (let index = 0, length: number = labels.length; index < length; ++index) {
            const label: HTMLElement = labels[index];
            label.style.setProperty('margin-left', `${this.props.scrollLeft || 0}px`);
            label.style.setProperty('z-index', '1');
            label.style.setProperty('box-shadow', 'white 1px 0');
        }
        const inputs: NodeListOf<HTMLElement> = ref.querySelectorAll('div[class^="input"]');
        for (let index = 0, length: number = inputs.length; index < length; ++index) {
            const input: HTMLElement = inputs[index];
            input.style.setProperty('margin-left', `-${this.props.scrollLeft || 0}px`);
        }
    }

    setLoaderStyle(ref: any): void {
        if (ref === null) {
            return;
        }
        const div: HTMLElement = ref.querySelector('div[class^="loader"]')
        if (div && div.style) {
            div.style.setProperty('z-index', '3');
            const span: HTMLElement = div.querySelector('div > span:nth-child(1)');
            if (span && span.style) {
                span.style.setProperty('background-color', 'lightgray');
            }
        }
    }

    setJahrBis(jahr: number) {
        let jahr_von = this.state.jahr_von;

        if (jahr_von < jahr - this.yearRange + 1) {
            jahr_von++;
        }
        this.setState({ jahr_bis: jahr, jahr_von }, this.saveJahre);
    }

    setJahrVon(jahr: number) {
        let jahr_bis = this.state.jahr_bis;

        if (jahr_bis > jahr + this.yearRange - 1) {
            jahr_bis--;
        }
        console.log('Jahr', jahr, jahr_bis);
        this.setState({ jahr_von: jahr, jahr_bis }, this.saveJahre);
    }

    onMouseEnter(evt: any, formKey: string) {
        if (this.enableFormShowMode) {
            const hasDatePicker = document.querySelector(`.${formStyle.formCompact} .react-datepicker`) !== null;
            if (
                // Linke Mousetaste wird beim Text-markieren gedrückt.
                evt.buttons === 1
                // Ignoriere, wenn onMouseLeave durch den Systemeingabevorschlag getriggert ist.
                // Dabei evt.nativeEvent.relatedTarget = null
                || !evt.nativeEvent.relatedTarget
                // Das aktuelle Formular enthält einen aktiven React-datepicker.
                || hasDatePicker
            ) {
                return;
            }
            // WKETOOL-26: 1515 Problem beim Datepicker (nur mit Firefox)
            // Ignoriere, wenn onMouseLeave durch den DatePicker getriggert ist.
            if (evt.nativeEvent.relatedTarget && evt.nativeEvent.relatedTarget.classList) {
                const classList = Array.from(evt.nativeEvent.relatedTarget.classList);
                if (classList.find((cls: string) => cls.startsWith('react-datepicker'))) {
                    return;
                }
            }
            if (this.state.activeFormKey !== formKey) {
                this.setState({ activeFormKey: formKey });
            }
        }
    }

    toggleShowBereich(entity: any): void {
        entity = entity || {};
        const showBereich = entity.entity === 'jahre' || this.state.showBereiche[entity.entity] || this.state.showBereiche['showAll'];
        const isCloseable: boolean = entity.entity !== 'jahre' && showBereich && !this.state.showBereiche.showAll;
        const isOpenable: boolean = entity.entity !== 'jahre' && !showBereich;
        const showBereiche: any = this.state.showBereiche || {};
        if (isOpenable) {
            showBereiche[entity.entity] = true;
        } else if (isCloseable) {
            delete (showBereiche[entity.entity]);
        } else {
            return;
        }
        this.setState({ showBereiche }, () => this.contextService.set('energieDatenKomplexBereiche', this.state.showBereiche));
    }

    getFormExtraElement(isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any,
        setValues: (values: any) => void, disabled?: boolean, id?: number, showMode?: boolean, styleProps?: React.CSSProperties): JSX.Element {
        let headerLabel = 'Befragung';
        const showBtn = true;
        const kampagneWrapper = entity.entity === IDs.ENT_ANABREISE ?
            <DateneingabeAnAbreiseDetailWrapper
                layout={'sidebysideComplexGreen'}
                rowTid={(values || {}).tid}
                data={this.props.data}
            />
            : entity.entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE ?
                <DateneingabePendelnKampagneWrapper
                    layout={'sidebysideComplexGreen'}
                    rowTid={(values || {}).tid}
                    data={this.props.data}
                />
                : undefined;
        const helpIcon: JSX.Element = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ marginRight: 10 }}
            styleProps={{ margin: 0 }}
            label={`Info "${headerLabel}"`}
            helpKey={`${IDs.MOD_ETOOL}_${entity.entity}__befragung`}
            type='theme_info'
            style='theme_small'
            editBar
            useTheme
        />;

        if (showMode) {
            return <div className={formStyle.fieldBox}>
                {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
                <div className={formStyle.input}></div>
            </div>;
        }
        return <div className={formStyle.fieldBox}>
            {isFirst && <div className={formStyle.label}>{helpIcon}<div>{headerLabel}</div></div>}
            <div className={formStyle.input}>
                {showBtn && kampagneWrapper}
            </div>
        </div>;
    }
}
